import Route from 'cio/routes/base';
import LogsController from 'cio/pods/logs/list/controller';

export default class LogsListRoute extends Route {
  deactivate() {
    super.deactivate();

    (this.controller as LogsController).setProperties({
      type: '',
      name: '',
    });
  }
}
